'use client';
import type { MenuCategoryType } from '@lib/sanity/queries/menu/types';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import { usePathname } from 'next/navigation';
import { HTMLAttributes } from 'react';

export interface CategoryProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: MenuCategoryType['title'];
  className?: string;
}

function Category({ title, className }: CategoryProps) {
  const pathname = usePathname();
  const isBlogRoute = typeof pathname === 'string' && pathname.includes('/blog');
  return (
    <div
      className={cn(className, 'bg-input border-border border-y py-2.5 pl-3 sm:pl-8', {
        'md:border-0 md:bg-transparent md:p-0': isBlogRoute,
        'lg:border-0 lg:bg-transparent lg:p-0': !isBlogRoute,
      })}
    >
      <Text
        content={title?.value}
        className="text-foreground lg:text-accent-foreground"
        variant={TextVariant.TextUnicase}
      />
    </div>
  );
}

export default Category;
